import { render, staticRenderFns } from "./CustomerBasicDataComponent.vue?vue&type=template&id=0e77cf50&"
import script from "./CustomerBasicDataComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports